"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SearchBox", {
    enumerable: true,
    get: function() {
        return SearchBox;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useSearchBox = require("./useSearchBox");
const _renderSearchBox = require("./renderSearchBox");
const _useSearchBoxStylesstyles = require("./useSearchBoxStyles.styles");
const SearchBox = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useSearchBox.useSearchBox_unstable)(props, ref);
    (0, _useSearchBoxStylesstyles.useSearchBoxStyles_unstable)(state);
    return (0, _renderSearchBox.renderSearchBox_unstable)(state);
});
SearchBox.displayName = 'SearchBox';
